<template>
    <div class="py-6">
        <div class="script-container">
            <div class="bg-white shadow-md rounded-lg overflow-hidden">
                <div class="p-6">
                    <div ref="scriptContainer" class="w-full min-h-[500px]"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'

defineProps({
    property: { type: Object, default: null },
    tabData: { type: Object, default: () => ({}) },
})

const scriptContainer = ref(null)

onMounted(() => {
    const script = document.createElement('script')
    script.src = 'https://www.mortgageresearchcenter.com/scripts/rentRisk.js'
    script.async = true
    script.setAttribute('data-mrc', 'RentRisk')
    script.setAttribute('data-mrc-color', '#c3a123')
    script.setAttribute('data-mrc-color-hover', '#323c61')
    // Applicant VA finance widget (same as standalone /va-loan page)
    script.setAttribute('data-mrc-desc', 'vafinance')

    script.onerror = () => console.error('Failed to load VA Loan script')

    if (scriptContainer.value) {
        scriptContainer.value.appendChild(script)
    }
})
</script>
